'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _LogoLink = require('./LogoLink.scss');var _LogoLink2 = _interopRequireDefault(_LogoLink);
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var LogoLink = function LogoLink(_ref) {var locale = _ref.locale,translate = _ref.translate,clickHome = _ref.clickHome,logo = _ref.logo;return (
    _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(locale, '/'), className: _LogoLink2.default.logoLink },
      _react2.default.createElement('img', {
        alt: '',
        width: '25px',
        className: _LogoLink2.default.logoSmall,
        src: _constants.onMapLogoMobile,
        title: '' + translate('header', 'onMapHomepage'),
        onClick: clickHome })));};




LogoLink.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  clickHome: _propTypes2.default.func,
  logo: _propTypes2.default.string };exports.default =


LogoLink;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LogoLink/LogoLink.js
// module id = 2715
// module chunks = 0